
import { User, OpencuiClient, OpencuiClientConfig } from '@opencui/copilot-react';

export let copilotInstance: OpencuiClient;
export function getCopilotInstance(configuration?: OpencuiClientConfig): OpencuiClient {
  let config: OpencuiClientConfig | undefined = configuration;
  if (!config) {
    config = { url: '' };
  }

  if (!config.url || !config.url.length) {
    const urlCache = window.localStorage.getItem('copilot-url');
    if (urlCache && urlCache !== 'undefined') {
      config.url = urlCache;
    }
  }

  if (!config.user) {
    const userCache = window.localStorage.getItem('copilot-user');
    if (userCache && userCache !== 'undefined') {
      config.user = JSON.parse(userCache);
    }
  }

  if (!copilotInstance) {
    copilotInstance = OpencuiClient.create(config);
  }

  return copilotInstance;
}

export function setCopilotUrl(url: string, packageName: string) {
  window.localStorage.setItem('copilot-url', url);
  copilotInstance.setUrl(url);
}

export function setCopilotUser(user: User): void {
  window.localStorage.setItem('copilot-user', JSON.stringify(user));
  copilotInstance.setUser(user);
}
